<template>
  <el-form :inline="true" class="inline-form" label-position="top">
    <el-form-item label="Модель">
      <el-select v-model="income.model" filterable placeholder="Найти">
        <el-option
          v-for="item in chicas"
          :key="item.name"
          :label="`${item.type} ${item.name}`"
          :value="item.name"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="Сумма">
      <el-input v-model.number="income.amount" type="number" />
    </el-form-item>
    <el-form-item label="Проверки на бомжа">
      <el-space>
        <el-input
          v-model.number="income.success_poor_detects"
          type="number"
          placeholder="Успешные"
        />
        <el-input
          v-model.number="income.failed_poor_detects"
          type="number"
          placeholder="Неуспешные"
        />
      </el-space>
    </el-form-item>
    <el-form-item label="Общаюсь сейчас">
      <el-input v-model.number="income.in_progress" type="number" />
    </el-form-item>
    <el-form-item label="Непрочитанные">
      <el-input v-model.number="income.unread" type="number" />
    </el-form-item>
    <el-form-item label="Комментарий">
      <el-input v-model.trim="income.comment" type="textarea" />
    </el-form-item>
    <el-form-item label="Скриншоты">
      <el-upload multiple :auto-upload="false" accept="image/*" v-model:file-list="screenshots">
        <el-button>
          <el-space
            >Загрузить все <el-icon><upload-filled /></el-icon> </el-space
        ></el-button>
      </el-upload>
    </el-form-item>
    <template v-if="props.isExtended">
      <el-form-item>
        <el-button type="primary" @click="addIncome">Добавить</el-button>
      </el-form-item>
    </template>
  </el-form>
</template>
<script setup lang="ts">
import type { IncomeToCreate } from '@/api/resources/incomes.ts/model'
import { chicas } from '@/data/chicos'
import { UploadFilled } from '@element-plus/icons-vue'
import type { UploadFile } from 'element-plus'

const props = defineProps({
  isExtended: {
    type: Boolean,
    default: false,
  },
})

const income = defineModel<Partial<IncomeToCreate>>({ required: true })
const screenshots = defineModel<UploadFile[]>('screenshots')

const emit = defineEmits<{
  (e: 'update:modelValue', income: IncomeToCreate, screenshots: UploadFile[]): void
}>()

const addIncome = async () => {
  emit('update:modelValue', income.value as IncomeToCreate, screenshots.value ?? [])
}
</script>

<style lang="scss">
.inline-form {
  .el-input {
    --el-input-width: 150px;
  }
  .el-select {
    --el-select-width: 300px;
  }
}
.el-form-item:last-child {
  margin-top: 30px;
  :deep(.el-form-item__content) {
    justify-content: flex-end;
  }
}
</style>
